import { PLAN_CATALOG } from '@icetus/contracts';

type PlanNames = Record<string, { name?: { zh?: string } } | undefined>;

const CATALOG = PLAN_CATALOG as unknown as PlanNames;

/**
 * 套餐代码 → 客户看得懂的名字（启航版 / 成长版 / 企业版）。
 *
 * 界面上不要直接渲染 `growth` 这类内部代码：它是接口和数据库里的标识，
 * 客户在定价页看到的是「成长版」，到了站点卡片右上角却变成 `growth`，
 * 会以为那是另一个东西（或干脆不知道自己是哪一档）。
 *
 * 认不出来的代码原样返回 —— 平台先上了新套餐、控制台还没更新时，
 * 至少还有一个标识可看，而不是一片空白。
 */
export function planLabel(code: string): string {
  return CATALOG[code]?.name?.zh ?? code;
}
